export const environment = {
    production: false,
    testEnv: false,
    apiUrl: 'https://demo-api.adsprism.net/',
    serviceUrl: 'https://demo-api.adsprism.net/',
    geoserverUrl: 'https://demo-api.adsprism.net/',
    domainURL: 'https://demo.adsprism.net/',
    legacySliicerImportUrl: 'https://ads-sliicer-legacy-import-dev.adsprod3.p.azurewebsites.net/',
    powerBIServiceUrl: 'https://adspowerbi-dev.adsprod3.p.azurewebsites.net/',
    exportStormUrl: 'https://ads-sliicer-data-export-api-dev.azurewebsites.net/',
    adalConfig: {
        tenant: 'adswastewater.onmicrosoft.com',
        clientId: '6b3c3863-2d40-4328-8bd8-9f65a21980ab',
        redirectUri: window.location.origin + '/',
        postLogoutRedirectUri: window.location.origin + '/',
    },
    mapApiKey: 'AIzaSyBlTbBKMgykRlUEwoqM1oH8XslO9lrCVhk',
    showOnlyCrowdcore: false,
    appInsights: {
        instrumentationKey: 'e963a06b-5423-44ea-8f04-8533c6292d57',
    },
    disableTestUser: false,
    showImportExportButtons: false,
    disableTestItems: false,
    enableSliicer: true,
    enableDataEditing: true,
    exportStormUserId: 'ADS',
    exportStormPassword: 'PintaNinaSantaMaria',
    workOrderLink: 'https://ads.crm.dynamics.com/main.aspx?appid=0cabfed9-9f2a-ef11-840b-000d3a573acb&pagetype=entityrecord&etn=msdyn_workorder',
    cookiesScriptUrl: 'https://cdn-cookieyes.com/client_data/cfd74dfd640c097c71f1f1a7/script.js',
    flexmonsterLicense: 'Z76X-XIAB0T-066P2Q-3L0L5Y-6M4B1T-700V6S-6E473I-044U62-1M6L1V-6G6K52-4N3M',
    lcLicenseNumber: '',
    clarityKey: 'jnggspx6bk'
};
